/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefinementCriterionResponse
 */
export interface RefinementCriterionResponse {
    /**
     * 
     * @type {string}
     * @memberof RefinementCriterionResponse
     */
    criterion: string;
    /**
     * 
     * @type {boolean}
     * @memberof RefinementCriterionResponse
     */
    hasMatched: boolean;
}

/**
 * Check if a given object implements the RefinementCriterionResponse interface.
 */
export function instanceOfRefinementCriterionResponse(value: object): value is RefinementCriterionResponse {
    if (!('criterion' in value) || value['criterion'] === undefined) return false;
    if (!('hasMatched' in value) || value['hasMatched'] === undefined) return false;
    return true;
}

export function RefinementCriterionResponseFromJSON(json: any): RefinementCriterionResponse {
    return RefinementCriterionResponseFromJSONTyped(json, false);
}

export function RefinementCriterionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefinementCriterionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'criterion': json['criterion'],
        'hasMatched': json['hasMatched'],
    };
}

export function RefinementCriterionResponseToJSON(value?: RefinementCriterionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'criterion': value['criterion'],
        'hasMatched': value['hasMatched'],
    };
}

